import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const Audience = ({ audiences }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Audience')} data={audiences} pluralText={i18n.getString(_TL_('audiences'))} singularText={i18n.getString(_TL_('audience'))} />
  );
};

Audience.propTypes = {
  audiences: PropTypes.arrayOf(PropTypes.shape({})),
};

Audience.defaultProps = {
  audiences: [],
};
